// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import type { AxiosError } from 'axios';

import { objectKeysToCamelCase } from '../utils/objectKeysTo.js';

export function responseErrorDataToCamelCase(err: AxiosError) {
  if (err.response) {
    // Flag is flat-spread onto the axios config via upstream's makeConfig
    // from our fork's ClientOptions (`@mint-lib/api-zod-support`).
    const camelCaseBody = (
      err.response.config as { response?: { camelCaseBody?: boolean } }
    )?.response?.camelCaseBody;
    if (camelCaseBody === false) {
      throw err;
    }
    throw {
      ...err,
      response: {
        ...err.response,
        // @ts-ignore TS2345: Argument of type 'unknown' is not assignable to parameter of type 'AxiosResponse<any, any>'.
        data: objectKeysToCamelCase(err.response.data),
      },
    };
  }
  throw err;
}
